<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="brandLogo"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col v-if="this.loadpage == false" sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <div class="text-center">
            <b-spinner
              style="width: 5rem; height: 5rem;"
              variant="primary"
              label="Large Spinner"
            />
          </div>
        </b-col>
        <b-col v-if="this.loadpage == true" sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="">
            <h4 class="display-4 text-center">สมัครสมาชิก</h4>
          </b-card-title>
          <!-- <b-button block class="px-0 py-0">
            <fb-signin-button
              :params="fbSignInParams"
              @success="onSignInSuccess"
              @error="onSignInError"
            >
                Sign in with Facebook
            </fb-signin-button>
          </b-button> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <h2 class="divider-text ">
              หรือลงทะเบียนโดยกรอกข้อมูล
            </h2>
          </div> -->

          <div class="pb-1 d-block d-lg-none">
            <b-img
              fluid
              :src="brandLogo"
              alt="Register V2"
            />
          </div>

          <!-- form -->
          <validation-observer
            ref="registerForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-register-form mt-2"
              @submit.prevent="btnRegister"
            >
            <!-- firstname -->
              <b-form-group
                label="ชื่อ"
                label-for="register-firstname"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Firstname"
                  vid="firstname"
                  rules="required"
                >
                  <b-form-input
                    id="register-firstname"
                    v-model="name"
                    name="register-firstname"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- phone -->
              <b-form-group
                label="เบอร์โทรศัพท์"
                label-for="register-phone"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Phone"
                  vid="phone"
                  rules="required"
                >
                  <b-form-input
                    id="register-phone"
                    v-model="phone"
                    name="register-phone"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group
                label="Email"
                label-for="register-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required"
                >
                  <b-form-input
                    id="register-email"
                    v-model="userEmail"
                    name="register-email"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- contact -->
              <b-form-group
                label="ต้องการ"
                label-for="register-contact"
              >
                <b-form-radio-group
                  v-model="needContact"
                  :options="contactOptions"
                  name="radio-validation"
                >
                </b-form-radio-group>
                <small v-if="valContact == false" class="text-danger">กรุณาเลือกความต้องการ</small>
              </b-form-group>

              <!-- line id -->
              <b-form-group
                label="LineID"
                label-for="register-line"
              >
                <b-form-input
                  id="register-line"
                  v-model="lineId"
                  name="register-line"
                />
              </b-form-group>

              <!-- username -->
              <b-form-group
                label="Username"
                label-for="register-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  vid="username"
                  rules="required"
                >
                  <b-form-input
                    id="register-username"
                    v-model="username"
                    name="register-username"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group
                label-for="register-password"
                label="รหัสผ่าน"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="register-password"
                      v-model="password"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      :state="errors.length > 0 ? false:null"
                      name="register-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small v-if="valPassword == false && errors[0] == null" class="text-danger">รหัสผ่านไม่ตรงกัน</small>
                </validation-provider>
              </b-form-group>

              <!-- re-password -->
              <b-form-group
                label-for="register-re-password"
                label="ใส่รหัสผ่านอีกครั้ง"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Re-password"
                  vid="re-password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="register-re-password"
                      v-model="rePassword"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      :state="errors.length > 0 ? false:null"
                      name="register-re-password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                variant="primary"
                block
                type="submit"
                :disabled="invalid || loadButton == false"
              >
                <b-spinner v-if="loadButton == false" small />
                ลงทะเบียน
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> เข้าสู่ระบบ
            </b-link>
          </p>
        </b-col>
      </b-col>
    <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BSpinner,
  BInputGroupAppend, BImg, BCardTitle, BCardText, BFormRadioGroup,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { getBrand, getBranchId } from '@/branding'
import {header_token, token_api} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  components: {
    BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BSpinner,
    BInputGroupAppend, BImg, BCardTitle, BCardText, BFormRadioGroup,
    // logo
    VuexyLogo,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      brandLogo: getBrand().logo,
      name: '',
      phone: '',
      userEmail: '',
      needContact: null,
      lineId: '',
      username: '',
      password: '',
      rePassword: '',
      contactOptions: [
        { text: 'ต้องการให้พนักงานติดต่อกลับเพื่ออธิบายวิธีการสั่งสินค้าเพิ่มเติม', value: true },
        { text: 'ต้องการหาข้อมูลด้วยตัวเองก่อน', value: false },
      ],
      valContact: true,
      valPassword: true,
      sideImg: require('@/assets/images/pages/register-v2.svg'),

      refCode: null,
      parentId: null,
      // validation
      required,
      email,

      fbSignInParams: {
        scope: 'email,public_profile',
        return_scopes: true
      },
      loadButton: true,
      loadpage: true
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  async created() {
    this.loadpage = false
    await this.getRefCode()

    window.fbAsyncInit = function() {
      this.FB.init({
        appId      : '1480694965278815',
        cookie     : true,  // enable cookies to allow the server to access the session
        xfbml      : true,  // parse social plugins on this page
        version    : 'v11.0' // use graph api version 2.8
      });
    };
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    this.loadpage = true
  },
  watch: {
    password() {
      if ( this.password == this.rePassword ) {
        this.valPassword = true
      }
    },
    rePassword() {
      if ( this.rePassword == this.password ) {
        this.valPassword = true
      }
    },
  },
  methods: {
    async onSignInSuccess (res) {
      var resProfile = []
      var sToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.GAO0TlWsHDaP_KImlaG6MomhnomjHj5xTWMkrfoNUmw"
      var rToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjQ1NDMxOTM3LCJleHAiOjE2NDU0MzI1Mzd9.FoUDDNh6hBlWHtHKsagslOFU20v9aYVAhDX9SqKAajE"
      this.profile = []
      window.FB.api('/me', 'GET', { fields: 'id,name,email,picture' },
      async userInformation => {
        if(userInformation.id){
          if ( userInformation.id ) {
            let response = await axios.post(taobaoService_dotnet + 'app/Customer/facebook-login',
              {
                'userID': userInformation.id,
              },
              { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }}
            )
            resProfile = response.data
            if ( resProfile.message == 'success' && resProfile.redirectType == 1 ) {
              localStorage.setItem('resFacebook', JSON.stringify(userInformation))
              if (this.parentId == null) {
                this.$router.push({path: '/pages/login-facebook'});
              } else {
                this.$router.push({path: '/pages/login-facebook?id=' + this.parentId});
              }
            } else if ( resProfile.message == 'success' && resProfile.redirectType == 2 ) {
              await this.profile.push({
                'data': resProfile,
                'role': 'facebook',
                'ability': [
                  {action: "manage", subject: "normal"},
                  {action: "manage", subject: "Auth"},
                  {action: "manage", subject: resProfile.customerInfo.isSeeBankAccount == true ? "high1" : "normal" },
                  {action: "manage", subject: resProfile.customerInfo.isBlockWithdraw == false ? "high2" : "normal" },
                ]
              })
              useJwt.setToken(sToken)
              useJwt.setRefreshToken(rToken)
              localStorage.setItem('userData', JSON.stringify(this.profile[0]))
              localStorage.setItem('cusId', JSON.stringify(this.profile[0].data.customerInfo.customerID))
              localStorage.setItem('show_announce', true)
              localStorage.setItem('auth_token', resProfile.token)
              this.$ability.update(this.profile[0].ability)

              this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', this.profile[0].data.customerInfo.quantityCart)

              this.$router.replace(getHomeRouteForLoggedInUser(this.profile[0].role))

            }
          } else {
            console.log("User cancelled login or did not fully authorize.")
          }
        }
      })
    },
    onSignInError (error) {
      console.log('OH NOES', error)
    },

    async btnRegister() {
      if (this.needContact == null) {
        this.valContact = false
      } else if ( this.password != this.rePassword ) {
        this.valPassword = false
      } else if ( this.password == this.rePassword ) {
        this.loadButton = await false
        let response = await axios.post(
          taobaoService_dotnet + 'Jinmatai/sign-up',
          // 'https://localhost:5001/Jinmatai/sign-up',
          {
            "name": this.name,
            "phoneNumber": this.phone,
            "email": this.userEmail,
            "username": this.username,
            "password": this.password,
            "lineID": this.lineId,
            "isNeedContact": this.needContact,
            "parentID": this.parentId,
            "branchId": getBranchId()
          },
          { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }}
        )
        if (response.data.message == 'success') {
          this.$swal({
            icon: 'success',
            title: 'สมัครสมาชิกเรียบร้อย',
            text: 'ยินดีต้อนรับสู่ Jinmatai Cargo',
            confirmButtonText: '< เข้าสู่ระบบ',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          }).then(result => {
            if (result.value) {
              this.$router.push({
                path: '/login',
              });
            }
          })
        } else {
          this.$swal({
            icon: 'warning',
            title: 'สมัครสมาชิกไม่สำเร็จ',
            text: 'เนื่องจาก ' + response.data.message,
            confirmButtonText: 'เข้าใจแล้ว',
            customClass: {
              confirmButton: 'btn btn-warning',
            },
            buttonsStyling: false,
          })
        }
        this.loadButton = true
      }
    },

    async getRefCode() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const urlCode = await urlParams.get('ref')
      this.refCode = urlCode
      if (this.refCode != null && this.refCode != '') {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Customer/get-id-by-receive',
          {
            "receiveName": this.refCode
          },
          { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }}
        )
        this.parentId = response.data
      }
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style>
  .fb-signin-button {
    /* This is where you control how the button looks. Be creative! */
    display: inline-block;
    padding: 13px;
    width: 100%;
    border-radius: 3px;
    background-color: #4267b2;
    color: #fff;
  }
</style>
